export default __webpack_public_path__ + "static/bed-bath-beyond-7-b-467e361d7894449eae6de098200cf3c7.gif";